import createLucideIcon from '../createLucideIcon';

const Plus = createLucideIcon('Plus', [
  ['line', { x1: '12', x2: '12', y1: '5', y2: '19', key: 'pwfkuu' }],
  ['line', { x1: '5', x2: '19', y1: '12', y2: '12', key: '13b5wn' }],
]);

export default Plus;
